<mat-grid-list [cols]="1">
  <div class="chat-popup">
    <mat-list-item lines="none" class="close-icon">
      <mat-icon class="icon" (click)="closeChatModal($event)" slot="end">close</mat-icon>
    </mat-list-item>
    <form [formGroup]="formGroup">
      <mat-list-item class="search-input ion-margin" lines="none">
        @if (formGroup.get('searchControl').value != '' && formGroup.get('searchControl').value) {
        <mat-icon slot="start" color="danger" class="icon" (click)="clearNotesSearch()">close</mat-icon>
        }
        <input matInput formControlName="searchControl" type="text" placeholder="Search" (keyup.enter)="searchNotes()" />
        <mat-icon slot="end" color="primary" class="icon" (click)="searchNotes()">search</mat-icon>
      </mat-list-item>
    </form>
    @if (showSpinner) {
    <div class="mauto text-center">
      <mat-spinner class="mauto"></mat-spinner>
      <br />
    </div>
    } @if (!showSpinner) {
    <div #scrollMe [scrollTop]="scrollMe.scrollHeight" class="chat-container hideScrollBarPrimary hideScrollBarSecondary">
      @if (!showSpinner && deviceNotes.length == 0) {
      <p class="text-align-center">No results found.</p>
      } @if (deviceNotes.length > 0) {
      <div>
        @for (note of deviceNotes; track note) {
        <huge-row>
          @if (userId !== 0 && userId !== note.UserID) {
          <mat-col size="9" class="message external-message">
            <p class="username">{{ note.User }}</p>
            <p class="note">{{ note.Message }}</p>
            <div class="time">
              {{ note.Timestamp | date : 'shortTime' }}
            </div>
          </mat-col>
          } @if (userId !== 0 && userId == note.UserID) {
          <mat-col offset="3" size="9" class="message internal-message">
            <p class="username">You</p>
            <p class="note">{{ note.Message }}</p>
            <div class="time">
              {{ note.Timestamp | date : 'shortTime' }}
            </div>
          </mat-col>
          }
        </huge-row>
        }
      </div>
      }
    </div>
    }
    <huge-row class="text-area-section mat-align-items-center mat-padding-none">
      <mat-col size="10">
        <textarea autosize rows="3" [(ngModel)]="newNote" class="message-input hideScrollBarPrimary hideScrollBarSecondary"></textarea>
      </mat-col>
      <mat-col size="2">
        <button mat-button expand="block" fill="clear" color="primary" [disabled]="newNote === ''" class="message-btn" (click)="addNote()">
          <mat-icon slot="icon-only">send</mat-icon>
        </button>
      </mat-col>
    </huge-row>
  </div>
</mat-grid-list>
